// src/contexts/TranslationProvider.js
import { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { TranslationContext } from '@providers/TranslationContext';
import { setActiveLocale, preloadAllLocales, getCurrentLocale } from '@app/translations/translations';

const TranslationProvider = ({ children }) => {
    const [locale, setLocale] = useState(getCurrentLocale());
    const [translationsState, setTranslationsState] = useState({});

    useEffect(() => {
        // Preload all locales when the app initializes
        preloadAllLocales().then(() => {
            // Set the initial locale's translations
            setActiveLocale(locale).then((loadedTranslations) => {
                setTranslationsState(loadedTranslations);
            });
        });
    }, []); //eslint-disable-line

    const changeLocaleHandler = async (newLocale) => {
        const loadedTranslations = await setActiveLocale(newLocale);
        setLocale(getCurrentLocale());
        setTranslationsState(loadedTranslations);
    };

    const contextValue = useMemo(
        () => ({
            locale,
            translations: translationsState,
            changeLocale: changeLocaleHandler,
        }),
        [locale, translationsState]
    );

    return (
        <TranslationContext.Provider value={contextValue}>
            {children}
        </TranslationContext.Provider>
    );
};

TranslationProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export { TranslationProvider };
